import type { TFunction } from 'i18next';

/**
 * Resolve a variant's short i18n label (e.g. "International 10×10").
 *
 * The `game.variants.*Short` keys are lowercase camelCase (`internationalShort`),
 * but variant ids reach the UI in two casings: the `GameVariant` enum values are
 * UPPERCASE (`'INTERNATIONAL'`, carried by challenge/rematch/matchmaking objects),
 * while dropdowns pass the lowercase `VALID_VARIANT_STRINGS` (`'international'`).
 * Normalizing to lowercase here is what keeps both callers working — building the
 * key from an uppercase enum yields `game.variants.INTERNATIONALShort`, which does
 * not exist, so i18next returns the raw key and the uppercase-transform CSS renders
 * it as `GAME.VARIANTS.INTERNATIONALSHORT`.
 *
 * The `defaultValue` guards against a genuinely missing key so we degrade to the
 * plain id instead of ever leaking the raw translation key to the user.
 */
export function variantShortLabel(t: TFunction, variant: string): string {
  const lower = String(variant).toLowerCase();
  return t(`game.variants.${lower}Short`, { defaultValue: lower });
}
